// @flow

import * as React from 'react';
import styled from 'styled-components';
import { renderUnitSize } from '../../helpers/styleHelpers';
import { OffScreenSpan } from './AccessibilityText';

type Props = {
  onToggle: Function,
  outerSize: number,
  innerSize: number,
  active: boolean,
};

const Wrapper = styled.a`
  width: ${props => renderUnitSize(props.theme, props.size)};
  height: ${props => renderUnitSize(props.theme, props.size)};
  display: block;
  display: flex;
  align-items: center;
`;

const scaleBy = 1.25;

const InnerWrapper = styled.div`
  transition: all ease-in-out ${props => props.theme.transition.standard}ms;
  width: ${props => renderUnitSize(props.theme, props.size)};
  height: ${props => renderUnitSize(props.theme, props.size)};
  display: block;
  position: relative;
  transform: rotate(${props => (props.active ? 180 : 0)}deg)
    scale(${props => (props.active ? scaleBy : 1)});
`;

const lineHeight = 0.18;
const Line = styled.div`
  transition: all ease-in-out ${props => props.theme.transition.standard}ms;
  height: ${lineHeight * 100}%;
  width: 100%;
  background-color: ${props => props.theme.colors.dark};
  border-radius: 1px;
  transform-origin: 50% 50%;
  transform: rotate(${props => props.rotate}deg)
    scale(1, ${props => (props.rotate !== 0 ? 1 / 1.25 : 1)});
  opacity: ${props => (props.hide ? '0' : '1')};
`;
Line.defaultProps = {
  hide: false,
  rotate: 0,
};

const calculateTransform = input => input * 50 * (1 - lineHeight);
const LineWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: ${props => props.justify};
  transition: all ease-in-out ${props => props.theme.transition.standard}ms;
  transform: translateY(${props => calculateTransform(props.transform)}%);
`;
LineWrapper.defaultProps = {
  transform: 0,
};

class Hamburger extends React.Component<Props> {
  onToggle = (e: { preventDefault: Function }) => {
    e.preventDefault();
    this.props.onToggle();
  };

  render() {
    const { innerSize, outerSize, active } = this.props;
    return (
      <Wrapper
        onClick={this.onToggle}
        height={outerSize}
        width={innerSize}
        href="#nav">
        <InnerWrapper size={innerSize} active={active}>
          <LineWrapper transform={active ? 1 : 0} justify="flex-start">
            <Line rotate={active ? -45 : 0} />
          </LineWrapper>
          <LineWrapper justify="center">
            <Line hide={active} />
          </LineWrapper>
          <LineWrapper transform={active ? -1 : 0} justify="flex-end">
            <Line rotate={active ? 45 : 0} />
          </LineWrapper>
          <OffScreenSpan>Go to Navigation</OffScreenSpan>
        </InnerWrapper>
      </Wrapper>
    );
  }
}

export default Hamburger;



// WEBPACK FOOTER //
// ./src/components/primitives/Hamburger.js